export default __webpack_public_path__ + "static/media/330_dummy2016-beauty01-de.d80120c3.png";